import { render } from "./BackButton.vue?vue&type=template&id=4d3284a9&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=4d3284a9&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3284a9"],['__file',"src/components/BackButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d3284a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d3284a9', __exports__)) {
    console.log('reload')
    api.reload('4d3284a9', __exports__)
  }
  
  module.hot.accept("./BackButton.vue?vue&type=template&id=4d3284a9&scoped=true", () => {
    console.log('re-render')
    api.rerender('4d3284a9', render)
  })

}


export default __exports__